import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { useT } from "../i18n";

/** Aviso de versión nueva: las pestañas abiertas durante un deploy siguen
 *  ejecutando el bundle viejo (la SPA vive en memoria) — esto avisa al usuario
 *  para que recargue en vez de ver una mezcla de UI vieja con datos nuevos. */
export default function NewVersionBanner() {
  const t = useT();
  const initial = useRef<string | null>(null);
  const [newVersion, setNewVersion] = useState<string | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const d = await api.get<{ current_version: string }>("/version");
        if (initial.current === null) {
          initial.current = d.current_version;
        } else if (d.current_version !== initial.current) {
          setNewVersion(d.current_version);
        }
      } catch { /* sin red: silencio */ }
    };
    check();
    const timer = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(timer);
  }, []);

  if (!newVersion) return null;
  return (
    <div style={{
      position: "fixed", bottom: 18, left: "50%", transform: "translateX(-50%)",
      zIndex: 1400, display: "flex", alignItems: "center", gap: 14,
      background: "var(--clr-modal-solid)",
      backdropFilter: "var(--clr-blur)", WebkitBackdropFilter: "var(--clr-blur)",
      border: "1px solid var(--clr-border)",
      color: "var(--clr-text)", padding: "9px 10px 9px 20px",
      borderRadius: 999, boxShadow: "0 12px 40px rgba(0,0,0,0.28)",
      fontSize: "0.85rem", fontWeight: 500,
    }}>
      <span>{t("newVersion.updated", { version: newVersion })}</span>
      <button
        onClick={() => window.location.reload()}
        style={{
          background: "var(--clr-org-primary)", color: "#fff", border: 0, borderRadius: 999,
          padding: "6px 16px", fontSize: "0.82rem", fontWeight: 600, cursor: "pointer",
        }}
      >
        {t("newVersion.reload")}
      </button>
    </div>
  );
}
